import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_BOUYGUES_IN_STORE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'checkout/in-store/bouygues-telecom/error',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ERROR,
    component: () =>
      import('~/scopes/checkout/flows/bouygues-in-store/components/BouyguesMagicLinkError/BouyguesMagicLinkError.vue'),
    meta: {
      owners: ['bot-squad-partnerships-front'],
      layout: false,
      tracking: { contentGroup: 'In-Store Sales Checkout' },
    },
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.SELF,
    redirect: { name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART },
    component: () =>
      import('~/scopes/checkout/flows/bouygues-in-store/layout/BouyguesMagicLinkLayout/BouyguesMagicLinkLayout.vue'),
    meta: {
      owners: ['bot-squad-partnerships-front'],
      layout: false,
      tracking: { contentGroup: 'In-Store Sales Checkout' },
    },
    children: [
      {
        path: 'cart',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART,
        component: () =>
          import('~/scopes/checkout/flows/bouygues-in-store/pages/CartStep/CartStep.vue'),
      },
      {
        path: 'address-edition',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ADDRESSES,
        component: () =>
          import('~/scopes/checkout/flows/bouygues-in-store/pages/AddressesStep/AddressesStep.vue'),
      },
      {
        path: 'payment',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT,
        component: () =>
          import('~/scopes/checkout/flows/bouygues-in-store/pages/PaymentStep/PaymentStep.vue'),
      },
    ],
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId/payment-result/:paymentId?',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT_RESULT,
    component: () => import('~/scopes/checkout/pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        mode: ['authenticated'],
        redirection: {
          default: {
            name: ROUTES.AUTH.LOGIN,
            query: { bm_journey: 'bouygues_store_customer' },
          },
        },
      },
      tracking: { contentGroup: 'In-Store Sales Checkout' },
    },
  },
]

export default routes
